/*global module: true*/
import Home from 'model/service/home'
module.exports = function ($mod) {

    var $ = window.$;

    /* 城市组合的定义，在html模板中也有相应定义（需同步改动） */
    var cityGroupTable = [
        ['A','B','C','D','E'],
        ['F','G','H','I','J'],
        ['K','L','M','N','O','P'],
        ['Q','R','S','T','U','V','W'],
        ['X','Y','Z']
    ];
    var cityIndexTable = {};
    for (var i = 0, len = cityGroupTable.length; i < len; i++) {
        for (var j = 0, llen = cityGroupTable[i].length; j < llen; j++) {
            cityIndexTable[cityGroupTable[i][j]] = i;
        }
    }

    // 头部城市切换
    var cityscroll, cityGroupHeights = [], isCityShow = 0, setCityDialog, initCity;
    setCityDialog = function (cate) {
        var city = $mod.find('.cityArea');
        if (cate === 'show') {
            city.css('opacity', 0).show().animate({'opacity' : 1}, "fast");
            $mod.find('i', city.parent()).css({'display' : 'inline', 'opacity' : 0}).animate({'opacity' : 1}, "fast");
        } else if (cate === 'hide') {
            city.animate({'opacity' : 0}, "fast", function () { $(this).hide(); });
            $mod.find('i', city.parent()).animate({'opacity' : 0}, "fast", function () { $(this).css('display', 'none'); });
            $mod.find('.cityArea .top').children().removeClass('active');
            $mod.find('.letter-info').removeClass('active');
        }
    };
    $mod.find('.city-select-btn').click(function (event) {
        event.preventDefault();
        if ($mod.find('.cityArea').css('display') === 'none') {
            setCityDialog('show');
            setTimeout(function () {
                if (isCityShow === 0) {
                    cityscroll = $mod.find('.cityArea_k .bot');
                    var $cityGroups = $mod.find('[node-type~="city-selecter-city-group"]');
                    $cityGroups.each(function (i, el) {
                        cityGroupHeights[i] = $(el).outerHeight(true);
                    });
                    isCityShow = 1;
                }
            }, 500);
        } else {
            setCityDialog('hide');
        }
    });
    $mod.find('.cityArea .h-close').click(function (event) {
        event.preventDefault();
        setCityDialog('hide');
    });

    // 更多城市弹框内滚动
    $mod.find('[node-type~="city-selecter-nav-item"]').click(function (event) { // 向上按钮绑定单击事件
        event.preventDefault();
        if (!cityscroll.is(':animated')) { // 判断是否处于动画
            var $this = $(event.target);
            var h = 0, index = parseInt($this.attr('data-group'));
            $this.addClass('active').siblings().removeClass('active');
            var letter = $this.attr('data-letter');
            $mod.find('.letter-info').removeClass('active').filter(`[li-letter=${letter}]`).addClass('active');
            for (var i = 0; i < index; i++) {
                h += cityGroupHeights[i];
            }
            cityscroll.animate({
                scrollTop: h
            }, 400);
        }
    });

    $mod.find('.letter-info').click(function() {
        var $this = $(this);
        $this.addClass('active').siblings().removeClass('active');
        var letter = $this.attr('li-letter');
        $mod.find('.cityArea .top').find(`[data-letter=${letter}]`).addClass('active').siblings().removeClass('active');

    })

    // 点击其他区域隐藏
    $(window.document).click(function (event) {
        if (!$(event.target).parents().hasClass('city-show-list') && !$(event.target).hasClass('city-show-list') && !$(event.target).hasClass('city-select-btn') && !$(event.target).parents().hasClass('city-select-btn') ) {
            setCityDialog('hide');
        }
    });

    // $mod.find('.city-link').on('click', function(e) {
    //     // console.log('$(this)', $(this));
    //     let url = $(this).attr('href');
    //     // console.log('$(this)', url);
    //     e.preventDefault();
    //     Home.setcityCookie({
    //         cityId: $(this).data('city_id')
    //     }).then((response) => {
    //         if (response.code === 0) {
    //             location.href = url;
    //         }
    //     })
    // })
    Home.setcityCookie({
        cityId: $mod.data('city-code')
    }).then((response) => {
    })
};



// WEBPACK FOOTER //
// ./src/module/home-index/header/header-nav/city-selecter.js